import * as actions from "../actions/locationsActions";

const initialState = {
  data: [],
  isOpen: false,
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case actions.FETCH_LOCATIONS:
      return {
        ...state,
        data: action.data,
      };
    case actions.CREATE_LOCATION:
      return {
        ...state,
        isOpen: true, // toggle create/edit slide-in
      };
    case actions.UPDATE_LOCATION: {
      return {
        ...state,
        isOpen: true, // toggle create/edit slide-in
      };
    }
    case actions.SET_LOCATIONS:
      return {
        ...state,
        data: action.locations,
      };
    default:
      return state;
  }
}
